var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.75188 5.45801H19.1707C19.3193 5.51014 19.4541 5.59561 19.5646 5.70787C19.6751 5.82013 19.7585 5.95619 19.8083 6.10564C19.8581 6.25509 19.8731 6.41396 19.852 6.57008C19.8309 6.7262 19.7744 6.87542 19.6868 7.00633L14.5257 12.6835V19.909L10.3968 16.8123V12.6835L5.23578 7.00633C5.14813 6.87542 5.09161 6.7262 5.07055 6.57008C5.04948 6.41396 5.06443 6.25509 5.11425 6.10564C5.16407 5.95619 5.24743 5.82013 5.35795 5.70787C5.46848 5.59561 5.60323 5.51014 5.75188 5.45801Z",
    stroke: "#64748B",
    strokeWidth: 1.85798,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.004935262bb8d203b34048aac7e12ed6.svg";
export { ForwardRef as ReactComponent };